<template>
  <div>
    <h6>{{ question.label }} {{ question.required ? '*' : '' }}</h6>
    <div class="mb-2" v-html="question.description"></div>
    <b-form-group>
      <b-form-select
        v-model="answer"
        :options="timeOptions"
        :disabled="disabled"
      ></b-form-select>
      <b-button v-if="!!answer && !question.required" variant="link" size="sm" class="px-0 text-muted" @click="answer = null">
        {{ trans('clear') }}
      </b-button>
      <b-form-invalid-feedback :state="!!errors ? false : null">
        {{ (errors||[]).join(' ') }}
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
  export default {
    props: {
      value: String, // Time 00:00:00
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      errors: Array,
    },
    data() {
      return {
        trans: trans,
        answer: this.value || null
      }
    },
    computed: {
      timeOptions() {
        return (this.question.options.values || []).map((value, index) => {
          let text = moment(value, 'hh:mm:ss').format(this.question.options.format)
          let label = this.question.options.labels &&
            this.question.options.labels[index] ?
            this.question.options.labels[index] :
            null
          if (!!label) text = `${label} - ${text}`
          return {
            value: value,
            text: text,
            disabled: false
          }
        })
      },
    },
    watch: {
      answer() {
        if (!_.isEqual(this.value, this.answer))
          this.$emit('input', this.answer)
      },
      value() {
        this.answer = this.value || null
      },
    },
    mounted() {
      window['questionTimeSelection'+this.question.id] = this
    },
  }
</script>